const TeamMemberItem = ({ team }) => {
  const { name, avatar } = team || {};

  return (
    <div className="checkbox-container">
      <img src={avatar} className="team-avater" alt="team avater" />
      <p className="label">{name}</p>
    </div>
  );
};

export default TeamMemberItem;
